// How a person's scheduled hours for the week read at a glance.
//
// hoursTone is the Build Schedule badge's long-standing rule, moved here
// unchanged: grey at 0, green under 32, amber 32–39, red with an overtime
// mark at 40 and over.
export function hoursTone(h) {
  const overtime = h >= 40;
  const color = h <= 0 ? '#bdbdbd' : overtime ? '#c62828' : h >= 32 ? '#ef6c00' : '#388e3c';
  return { color, overtime };
}

// The hours a person said they want (profile → Hours wanted, both ends
// optional) against the hours they have. null when they gave no preference.
export function wantedFit(hours, min, max) {
  if (min == null && max == null) return null;
  const range = min != null && max != null ? (min === max ? `${min}` : `${min}–${max}`) : min != null ? `${min}+` : `up to ${max}`;
  const state = min != null && hours < min ? 'under' : max != null && hours > max ? 'over' : 'within';
  const gap = state === 'under' ? min - hours : state === 'over' ? hours - max : 0;
  const detail = state === 'within' ? 'Within the hours they want' : `${+gap.toFixed(1)} h ${state} the hours they want`;
  return { state, label: `wants ${range} h`, detail };
}
export const FIT_COLOR = { under: '#b26a00', over: '#c62828', within: '#388e3c' };

// Minutes between two 'HH:MM' times; 0 if either is missing.
export function spanHours(start, end) {
  const m = (t) => { const x = /^(\d{1,2}):(\d{2})/.exec(String(t || '')); return x ? Number(x[1]) * 60 + Number(x[2]) : null; };
  const a = m(start), b = m(end);
  return a == null || b == null || b <= a ? 0 : (b - a) / 60;
}
